import {
	CATEGORIES_GET_STATUS,
	CATEGORIES_GET,
	CATEGORIES_GET_ERROR,
	CATEGORIES_GET_BY_ID,
	CATEGORIES_CLEAR,
	CATEGORY_RESOURCES_GET,
	CATEGORY_RESOURCES_GET_STATUS,
	CATEGORY_RESOURCES_GET_ERROR,
	CATEGORY_GET_STATUS,
	CATEGORY_GET,
	CATEGORY_GET_ERROR,
	BREAD_CRUMBS_SET_STATUS,
	BREAD_CRUMBS_SET,
	RESOURCE_GET,
	RESOURCE_CLEAR,
	RESOURCE_GET_ERROR,
	RESOURCE_TOGGLE_VIEW,
	RESOURCE_GET_TYPES_LIST,
	RESOURCE_GET_TYPES_LIST_ERROR,
	RESOURCE_GET_AUTHORS_LIST,
	RESOURCE_GET_AUTHORS_LIST_ERROR,
	RESOURCE_TOGGLE_DEFAULT_VIEW,
} from './types'

import { resource } from '@/api'

const getResourcesAuthors = async (ctx, query) => {
	try {
		const { data, headers } = await resource.getAllAuthor(query)
		const pageCount = headers['x-pagination-page-count'] || 1
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']
		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
		ctx.commit(RESOURCE_GET_AUTHORS_LIST, response)
	} catch (e) {
		ctx.commit(RESOURCE_GET_AUTHORS_LIST_ERROR, e)
	}
}

const getResourcesTypes = async (ctx) => {
	try {
		const { data } = await resource.getAllTypes()
		ctx.commit(RESOURCE_GET_TYPES_LIST, data)
	} catch (e) {
		ctx.commit(RESOURCE_GET_TYPES_LIST_ERROR, e)
	}
}

const breadCrumbHandler = async (ctx, breadCrumb) => {
	ctx.commit(BREAD_CRUMBS_SET_STATUS, true)
	ctx.commit(BREAD_CRUMBS_SET, breadCrumb)
	ctx.commit(BREAD_CRUMBS_SET_STATUS, false)
}

const getResources = async (ctx, queryParams = '') => {
	ctx.commit(CATEGORIES_GET_STATUS, true)

	try {
		const { data, headers } = await resource.getResources(queryParams)

		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}

		ctx.commit(CATEGORIES_GET, response)

		ctx.commit(CATEGORIES_GET_STATUS, false)
	} catch (e) {
		ctx.commit(CATEGORIES_GET_ERROR, e)
		console.error(e)
	}
}

const getResourcesById = async (ctx, queryParams = '') => {
	ctx.commit(CATEGORIES_GET_STATUS, true)

	try {
		const { data, headers } = await resource.getResources(queryParams)

		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}

		ctx.commit(CATEGORIES_GET_BY_ID, response)
		ctx.commit(CATEGORIES_GET_STATUS, false)
	} catch (e) {
		ctx.commit(CATEGORIES_GET_ERROR, e)
		console.error(e)
	}
}

const getResource = async (ctx, categoryId) => {
	ctx.commit(CATEGORY_GET_STATUS, true)

	try {
		const { data, headers } = await resource.getResource(categoryId)

		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}

		ctx.commit(CATEGORY_GET, response)

		ctx.commit(CATEGORY_GET_STATUS, false)
	} catch (e) {
		ctx.commit(CATEGORY_GET_ERROR, e)
		console.error(e)
	}
}

const clearResources = async (ctx) => {
	try {
		ctx.commit(CATEGORIES_CLEAR)
	} catch (e) {
		ctx.commit(CATEGORY_GET_ERROR, e)
		console.error(e)
	}
}

const getCategory = async (ctx, categoryId) => {
	ctx.commit(CATEGORY_GET_STATUS, true)

	try {
		const { data } = await resource.getCategory(categoryId)
		ctx.commit(CATEGORY_GET, data)

		ctx.commit(CATEGORY_GET_STATUS, false)
	} catch (e) {
		ctx.commit(CATEGORY_GET_ERROR, e)
		console.error(e)
	}
}

const getCategories = async (ctx, queryParams = {}) => {
	ctx.commit(CATEGORIES_GET_STATUS, true)

	try {
		const { data, headers } = await resource.getCategories(queryParams)

		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
		ctx.commit(CATEGORIES_GET, response)

		ctx.commit(CATEGORIES_GET_STATUS, false)
	} catch (e) {
		ctx.commit(CATEGORIES_GET_ERROR, e)
		console.error(e)
	}
}

const getCategoryResources = async (ctx, { id: categoryId, queryParams = {} }) => {
	ctx.commit(CATEGORY_RESOURCES_GET_STATUS, true)

	try {
		const { data } = await resource.getCategoryResources(categoryId, queryParams)
		ctx.commit(CATEGORY_RESOURCES_GET, data)

		ctx.commit(CATEGORY_RESOURCES_GET_STATUS, false)
	} catch (e) {
		ctx.commit(CATEGORY_RESOURCES_GET_ERROR, e)
		console.error(e)
	}
}

const getResourceById = async (ctx, id) => {
	ctx.commit(CATEGORY_RESOURCES_GET_STATUS, true)

	try {
		const { data } = await resource.getResource(id)
		ctx.commit(RESOURCE_GET, data)
	} catch (e) {
		ctx.commit(RESOURCE_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(CATEGORY_RESOURCES_GET_STATUS, false)
	}
}

const clearResource = async (ctx) => {
	try {
		ctx.commit(RESOURCE_CLEAR)
	} catch (e) {
		console.error(e)
	}
}

const toggleListView = async (ctx) => {
	try {
		ctx.commit(RESOURCE_TOGGLE_VIEW)
	} catch (e) {
		console.error(e)
	}
}
const toggleDefaultListView = async (ctx) => {
	try {
		ctx.commit(RESOURCE_TOGGLE_DEFAULT_VIEW)
	} catch (e) {
		console.error(e)
	}
}

export default {
	getResources,
	getResourcesById,
	getResource,
	getCategories,
	getCategory,
	getCategoryResources,
	breadCrumbHandler,
	getResourceById,
	clearResource,
	clearResources,
	toggleListView,
	getResourcesTypes,
	getResourcesAuthors,
	toggleDefaultListView,
}
